import type { TOC } from "@ember/component/template-only";
import type { ComponentLike } from "@glint/template";

export interface EmptyStateIntroSignature {
  Args: {
    icon?: ComponentLike<{ Element: SVGElement }>;
    title?: string;
    description?: string;
  };
}

const EmptyStateIntro: TOC<EmptyStateIntroSignature> = <template>
  {{#if @icon}}
    <@icon
      class="mb-2 size-8 stroke-current stroke-[0.55] text-gray-400 dark:text-gray-500"
      aria-hidden="true"
      data-test-empty-state-icon
    />
  {{/if}}
  {{#if @title}}
    <h2 class="text-lg text-black dark:text-gray-100" data-test-empty-state-title>{{@title}}</h2>
  {{/if}}
  {{#if @description}}
    <p class="max-w-md text-sm text-gray-500 leading-normal text-balance" data-test-empty-state-description>
      {{@description}}
    </p>
  {{/if}}
</template>;

export default EmptyStateIntro;
